import React from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {_openModal, _removeModal} from '../../../store';
import BaseModal from './Base';
import Button from '../../Button';
import axiosInstance from '../../../utils/axios';
import Row from '../../Row';
import {DescriptiveText, LoadingSpinner} from '../../../index';
import {requireOneOf} from '../../../utils/proptypeAtleastRequiredOne';

const ConfirmModal = ({content, removeModal, openModal}) => {
  const {button, title} = content;
  let {buttons} = content;
  buttons = button ? [button] : buttons;

  const [body, setBody] = React.useState(content.body);
  const [showButtons, setShowButtons] = React.useState();
  const executeAction = (buttonDetails) => {
    if (buttonDetails && buttonDetails.action) {
      const result = buttonDetails.action(buttonDetails.data);
      if (result && typeof result.then === 'function') {
        return result.then(() => removeModal(content));
      }
    }
    removeModal(content);
  };

  React.useEffect(() => {
    if (content.body.type && content.body.name) {
      setBody(<LoadingSpinner/>);
      axiosInstance.get(`/config/assets/${content.body.type}/${content.body.name}`)
        .then(function resolveAsset(res) {
          setBody(<DescriptiveText>
            <div dangerouslySetInnerHTML={{__html: res.data.content}}/>
          </DescriptiveText>);
          setShowButtons(true);
        })
        .catch(err => {
          removeModal(content);
          openModal({type: 'Error', title: title, err});
        });
    } else {
      if (typeof content.body === 'string') {
        setBody(<DescriptiveText>{content.body}</DescriptiveText>);
      }
      setShowButtons(true);
    }
  }, []);
  return (
    <BaseModal onClose={() => removeModal(content)} title={title}>
      {body}
      {showButtons && <Row wrap={true}>
        <Button
          importance={(button?.cancelImportance) || 'secondary'}
          width={button?.width || 'auto'}
          size={(button?.size) || 'md'}
          label={button?.cancelText || 'Cancel'}
          disabled={false}
          action={() => removeModal(content)}>
        </Button>
        {
          buttons && buttons.map((buttonDetails, index) => <Button
            importance={buttonDetails?.confirmImportance || (buttons.length > 1 ? 'secondary' : 'primary')}
            width={buttonDetails?.width || 'auto'}
            size={(buttonDetails?.size) || 'md'}
            key={index}
            label={(buttonDetails?.text) || 'Confirm'}
            disabled={false}
            action={()=>executeAction(buttonDetails)}>
          </Button>)
        }
      </Row>}
    </BaseModal>
  );
};

const mapDispatchToProps = dispatch => ({
  removeModal: modal => dispatch(_removeModal(modal)),
  openModal: modal => dispatch(_openModal(modal)),
});

export default connect(null, mapDispatchToProps)(ConfirmModal);

const requireAtleastOne = requireOneOf({
  button: PropTypes.shape({
    text: PropTypes.string,
    action: PropTypes.func.isRequired,
    cancelText: PropTypes.string,
    cancelImportance: PropTypes.string,
    data: PropTypes.object,
    confirmImportance: PropTypes.string,
    size: PropTypes.oneOf(['sm', 'md', 'lg']),
    width: PropTypes.string,
  }),
  buttons: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    action: PropTypes.func.isRequired,
    data: PropTypes.object,
    confirmImportance: PropTypes.string,
    cancelImportance: PropTypes.string,
    size: PropTypes.oneOf(['sm', 'md', 'lg']),
    width: PropTypes.string,
  })),
});

ConfirmModal.propTypes = {
  openModal: PropTypes.func.isRequired,
  removeModal: PropTypes.func.isRequired,
  content: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    body: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.element,
      PropTypes.shape({
        type: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
      }),
    ]).isRequired,
    button: requireAtleastOne, // accepts only one obj with button configuration, will be deprecated in future
    buttons: requireAtleastOne, // accepts array of button
  }).isRequired,
};
